import React, { useEffect, useState } from "react";
import "./Volumes.css";
import { ApiUrl, BaseUrl } from "../../../Admin/API/ApiUrl";
import { ArrowLeft, BookOpen, FileText } from "lucide-react";
import { useQuery } from "@tanstack/react-query";


export default function Volumes() {


//  fetch function
const fetchVolumes = async () => {
  const res = await fetch(`${ApiUrl}/journal-volumes`);
  const data = await res.json();

  if (!res.ok) {
    throw new Error("Failed to fetch volumes");
  }

  return data || [];
};

//  TanStack Query
const {
  data: volumes = [],
  isLoading,
  isError
} = useQuery({
  queryKey: ["journalVolumes"],
  queryFn: fetchVolumes,
  staleTime: 10 * 60 * 1000,
});

const [selectedVolume, setSelectedVolume] = useState(null);
const [selectedIssue, setSelectedIssue] = useState(null);

if (isLoading) return null;

  return (
    <section className="ijacna-volumes-section">
      <div className="ijacna-volumes-container">

        <h2 className="ijacna-volumes-heading">Journal Volumes</h2>
        <p className="ijacna-volumes-subtext">
          Explore all published volumes and issues of the International Journal
          of Advanced Computing and Network Applications.
        </p>
        <div className="ijacna-volumes-table-wrapper">

          {/* ---------------- VOLUMES ---------------- */}
          {!selectedVolume && (
            <table className="ijacna-volumes-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Volume</th>
                  <th>Year</th>
                </tr>
              </thead>

              <tbody>
                {volumes.map((item, index) => (
                  <tr
                    key={item.id}
                    onClick={() => setSelectedVolume(item)}
                    style={{ cursor: "pointer" }}
                  >
                    <td>{index + 1}</td>
                    <td className="volume-cell">
                      <span className="volume-link">
                        <BookOpen size={16} className="icon" />
                        Volume {item.volume}
                      </span>
                    </td>
                    <td>{item.year}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {/* ---------------- ISSUES ---------------- */}
          {selectedVolume && !selectedIssue && (
            <>
              <button
                className="ijacna-back-btn"
                onClick={() => setSelectedVolume(null)}
              >
                <ArrowLeft size={14} className="ijacna-back-icon" />
                Back
              </button>
              <table className="ijacna-volumes-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Issue</th>
                    <th>Month / Year</th>
                  </tr>
                </thead>

                <tbody>
                  
                  {selectedVolume.issues.length > 0 ? (
                  
                  selectedVolume.issues.map((issue, index) => (
                    <tr
                      key={issue.id}
                      onClick={() => setSelectedIssue(issue)}
                      style={{ cursor: "pointer" }}
                    >
                      <td>{index + 1}</td>
                      <td className="issue-cell">
                        <span className="issue-link">
                          <FileText size={16} className="icon" />
                          Issue {issue.issue}
                        </span>
                      </td>
                      <td>{issue.monthYear}</td>
                    </tr>
                   ))
                  ) : (
                    <tr>
                      <td colSpan="5">No Issues Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </>
          )}

          {/* ---------------- ARTICLES ---------------- */}
          {selectedIssue && (
            <>
              <button
                className="ijacna-back-btn"
                onClick={() => setSelectedIssue(null)}
              >
                <ArrowLeft size={14} className="ijacna-back-icon" />
                Back
              </button>
              <table className="ijacna-volumes-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Topic</th>
                    <th>Author</th>
                    <th>Pages</th>
                    <th>Download</th>
                  </tr>
                </thead>

                <tbody>
                  {selectedIssue.articles.length > 0 ? (
                    selectedIssue.articles.map((article, index) => (
                      <tr key={article.id}>
                        <td>{index + 1}</td>
                        <td>{article.topic}</td>
                        <td>{article.author}</td>
                        <td>{article.pages}</td>

                        <td>
                          <a
                            href={`${BaseUrl}${article.file_path}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Download
                          </a>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5">No Articles Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </>
          )}

        </div>
      </div>
    </section>
  );
}